import { localStorage as getLocalStorage } from 'mage-common';
import actions from './actions';
const middleware = ({ localStorage: storage } = {}) => next => action => {
    const localStorage = getLocalStorage({ storage });
    switch (action.type) {
        case actions.keycloak.realm.set.toString():
            localStorage.set('realm', action.payload);
            break;
        case actions.keycloak.realm.clear.toString():
            localStorage.remove('realm');
            break;
    }
    return next(action);
};
export default middleware;
